module.exports = __webpack_public_path__ + "img/paragraph.604677a9.svg";